<template>
  <form
    ref="form"
    :action="formAction"
    :class="{'opacity-50': isWorking}"
    autocomplete="on"
    method="post"
    @submit.prevent="submit"
  >
    <callout v-if="message" :icon="messageIcon" :type="messageType">
      {{ message }}
    </callout>
    <form-group
      v-model="email"
      v-validate="'required|email'"
      type="email"
      name="j_username"
      :label="bp('login.email')"
      :data-vv-as="bp('login.email')"
      :error="errors.first('j_username')"
      :show-error-messages="true"
    />
    <form-group
      v-model="password"
      v-validate="'required'"
      type="password"
      name="j_password"
      :label="bp('login.password')"
      :data-vv-as="bp('login.password')"
      :error="errors.first('j_password')"
      :show-error-messages="true"
    />
    <form-group
      type="checkbox"
      name="_spring_security_remember_me"
      :multi-items="[{displayName: bp('login.remember'), checked: rememberMe, value: true}]"
      qaid="login-remember-me"
      @change="
        (e) => {
          rememberMe = e.target.checked;
        }
      "
    />

    <trek-button primary :disabled="isWorking" type="submit" class="mb-4">
      <span v-html="bp('login.login')" />
    </trek-button>
    <div class="text-sm">
      <a
        :href="withContextPath('/login/pw/request/external/')"
        class="hover:underline"
        v-html="bp('forgottenPwd.title')"
      />
    </div>
  </form>
</template>
<script>
import {Url} from '@/utils/url';
import Callout from '@/components/Callout';
import FormGroup from '@/components/FormGroup';
import TrekButton from '@/components/TrekButton';
import {suppressGlobalErrorMessages} from '@/utils/global-error-messages';
import {FormMessage} from '@/components/containers/my-account/utils/form-message';
import {UserAccountBase} from '@/components/containers/my-account/utils/user-account-base';

export default {
  name: 'UserLogin',
  components: {Callout, FormGroup, TrekButton},
  extends: UserAccountBase,
  mixins: [FormMessage],
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isWorking: false,
      rememberMe: false,
      email: '',
      password: '',
    };
  },
  computed: {
    formAction() {
      return `${this.bp('login.action.pagename') || ''}/j_spring_security_check`;
    },
  },
  mounted() {
    if (this.isGlobalErrorMessageVisible()) {
      this.displayError(this.bp('login.error.account.not.found.title'));
      suppressGlobalErrorMessages();
    }
  },
  created() {
    this.useCustomPasswordValidationMessages({
      passwordField: 'password',
    });
  },
  methods: {
    withContextPath: (url) => Url.withContextPath(url),

    /**
     * Check whether a global message should be displayed or not.
     * @return boolean
     */
    isGlobalErrorMessageVisible() {
      return window.location.search && window.location.search.indexOf('error=true') > -1;
    },

    /**
     * Handle form submission & validate data.
     * @return {Promise<void>}
     */
    submit() {
      this.hideMessage();
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.isWorking = true;
          this.$refs.form.submit();
        }
      });
    },
  },
};
</script>
